<template>
    <div class="notification">
        <div class="notification__text">
            {{ data.msg }}
        </div>

        <button class= "notification__button"
                v-if="data.actionText"
                @click="action"
        >
            {{ data.actionText }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object
        }
    },
    created() {
        if (this.data.time) {
            setTimeout(() => {
                this.done();
            }, this.data.time);
        }
    },
    methods: {
        action() {
            if (this.data.actionCallback) {
                this.data.actionCallback(this.done);
            } else {
                this.done();
            }
        },
        done() {
            this.$store.dispatch('notifications/remove', this.data);
        }
    }
};
</script>

<style scoped lang="scss">
    .notification {
        width: 100%;
        background-color: $color-gray;
        color: $color-white;
        padding: 0.375rem;
        display: flex;
        position: absolute;
        justify-content: space-between;
        font-size: 1.25rem;

        @include medium {
          font-size: 1.5rem;
        }

        @include extra-large {
            font-size: 2rem;
        }
    }

    .notification__text{
        flex:1;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .notification__button {
        font-size: 1.25rem;
        text-transform: uppercase;
        color: $color-white;
        font-weight: bold;
        cursor: pointer;
        background: 0;
        border: 0;
        outline: 0;

        @include medium {
            font-size: 1.5rem;
        }

        @include extra-large {
            font-size: 2rem;
        }
    }
</style>
